import { stickers, stickers_mini, icons } from './Resources';


const URL_REGEX = /\b(?:https?:\/\/|ftp:\/\/|www\.)[^\s]+/gi;
const HASHTAG_REGEX = /(^|\s)(#[\w]+)/g;
const MENTION_REGEX = /@\\w+/g;


const CollectionStatus = {
    COLLECTED: 'collected',
    WISHED: 'wished',
    ORDERED: 'ordered',
    NONE: 'none'
};

const FigureStatus = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    DRAFT: 'draft'
};

const SERVER_STATUS = {
    OK: 'ok',
    DOWN: 'down',
    MAINTENANCE: 'maintenance',
    ERROR: 'error',
    ERROR_AUTH: 'error_auth'    
};

const FEED_TYPES = {
    ME: 'me',
    PROFILE: 'profile',
    FOLLOWING: 'following',
    TRENDING: 'trending',
    SAVED: 'saved',
    COMPANY: 'company',
    GROUP: 'group'
};

const POST_VIEW_TYPES = {
    MINIMAL: 'minimal',
    FULL: 'full',
    PREVIEW: 'preview'
};


// Moved to WebViewTextEditor.js
const POST_TYPES = {
    TEXT: 'text',
    MEDIA: 'media',
    POLL: 'poll',
    FIGURE: 'figure',
    FIGURE_DATABASE_ENTRY: 'figure_database_entry',
    GIF: 'gif',
    BACKGROUND: 'background'
}
   
const STICKER_TYPES = [
    { id: "collected", label: "Collected", color: '#FF9B54', icon: stickers_mini.collected_mini, icon_full: stickers.collected },
    { id: "figure_news", label: "Figure News", color: '#5CB85C', icon: stickers_mini.figure_news_mini, icon_full: stickers.figure_news },
    { id: "for_sale", label: "For Sale", color: '#4399FF', icon: stickers_mini.for_sale_mini, icon_full: stickers.for_sale },
    { id: "looking_for", label: "Looking For", color: '#9747FF', icon: stickers_mini.looking_for_mini, icon_full: stickers.looking_for },
    { id: "trade_only", label: "Trade Only", color: '#4CD964', icon: stickers_mini.trade_only_mini, icon_full: stickers.trade_only },
    { id: "shelf_update", label: "Shelf Update", color: '#FFD60A', icon: stickers_mini.shelf_update_mini, icon_full: stickers.shelf_update },
    { id: "figure_review", label: "Figure Review", color: '#FF9500', icon: stickers_mini.figure_review_mini, icon_full: stickers.figure_review },
    { id: "mail_call", label: "Mail Call", color: '#FF453A', icon: stickers_mini.mail_call_mini, icon_full: stickers.mail_call },
    { id: "need_help", label: "Need Help", color: '#5AC8FA', icon: stickers_mini.need_help_mini, icon_full: stickers.need_help },
    { id: "trade_or_sell", label: "Trade or Sell", color: '#FF453A', icon: stickers_mini.trade_or_sell_mini, icon_full: stickers.trade_or_sell },
    { id: "unboxing", label: "Unboxing", color: '#FF453A', icon: stickers_mini.unboxing_mini, icon_full: stickers.unboxing }
];

const MENU_OPTIONS = [
    { id: 'media', icon: 'images', label: 'Media' },
    { id: 'figure', icon: 'body', label: 'Figure' },
    { id: 'people', icon: 'people', label: 'Tag People' },
    { id: 'emoji', icon: 'happy', label: 'Emojis' },
    { id: 'background', icon: 'grid', label: 'Background' },
    { id: 'gif', icon: 'text', label: 'GIFs' },
    { id: 'poll', icon: 'stats-chart', label: 'Poll' },
    { id: 'settings', icon: 'cog', label: 'Settings' }
];

const PUBLICITY_OPTIONS = [
    { id: 'anyone', text: 'Anyone', icon: 'earth'},
    { id: 'friends', text: 'Friends', icon: 'account-group'},
    { id: 'groups', text: 'Groups', icon: 'account-group'},
    { id: 'only_me', text: 'Only Me', icon: 'lock'}
];

const LAYOUT_OPTIONS = [
    { id: 'classic', label: 'Classic', icon: 'remove-circle-outline' },
    { id: 'columns', label: 'Columns', icon: 'pause' },
    { id: 'banner', label: 'Banner', icon: 'grid' },
    { id: 'frame', label: 'Frame', icon: 'square-outline' }
]

const getStickerByID = (id) => {
    return STICKER_TYPES.find(sticker => sticker.id === id);
}

const getPublicityByID = (id) => {
    return PUBLICITY_OPTIONS.find(publicity => publicity.id === id);
}   

export { URL_REGEX, HASHTAG_REGEX, MENTION_REGEX, CollectionStatus, FigureStatus };

export { SERVER_STATUS, FEED_TYPES, POST_TYPES, POST_VIEW_TYPES, STICKER_TYPES, MENU_OPTIONS, PUBLICITY_OPTIONS, LAYOUT_OPTIONS, getStickerByID, getPublicityByID };